module.exports = __webpack_public_path__ + "static/media/new-serena-lose.f6247772.png";